@if (garage && product) {
  <form [formGroup]="contractForm" (ngSubmit)="finish()">
    <div class="card-responsive mb-4">
      <div class="card-header">
        <div class="headline-x-small">
          <i class="max-md:text-2xl fa-kit fa-contract"></i>
          <span [innerText]="'Contracts.ContractDetails' | translate"></span>
        </div>
      </div>
      <div class="card-body">
        <div class="well flex gap-2 w-[100%] mb-6">
          <div class="flex items-center text-success-dark text-3xl">
            <i class="fa-kit fa-parking"></i>
          </div>
          <div class="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-2 md:gap-4">
            <div class="flex-1 text-left">
              <div class="body-large mb-0.5" [innerText]="garage.name"></div>
              <div class="body-small">
                <span class="text-neutral-50">
                  <span [innerText]="product.name"></span>
                  @if (contractForm.value.parkingSpots) {
                    <span>,&nbsp;</span
                    ><span [innerText]="'Contracts.ParkingSpaces' | translatePlural: { count: contractForm.value.parkingSpots }"></span>
                  }
                </span>
              </div>
            </div>
            <div class="flex md:items-center justify-between flex-col md:flex-row gap-2 lg:gap-8">
              <div class="flex flex-row md:flex-col gap-1 md:gap-0.5 text-right items-baseline md:items-end">
                <div class="headline-small">
                  <span class="text-interaction-dark font-bold" [innerText]="product.price.amount | localizedCurrency: product.price.currency"></span>
                </div>
                <div class="text-interaction-dark body-large" [innerText]="'Contracts.MonthlyPerParkingSpace' | translate"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="body-large text-decoration-dark text-left mb-2" [innerText]="'Contracts.ContractConditions' | translate"></div>
        <!-- Contract conditions column -->
        <div class="flex flex-col lg:flex-row gap-4 lg:gap-0">
          <!-- first column -->
          <div class="flex-1">
            <div class="flex gap-4 lg:mb-4">
              <!-- Start date -->
              <div class="ar-input-group text-start flex-1">
                <div class="input-primary-container relative">
                  <input
                    id="start"
                    class="input-primary"
                    type="text"
                    addEmptyPlaceholder
                    [matDatepickerFilter]="startDatepickerFilter"
                    [matDatepicker]="startDatepicker"
                    formControlName="start"
                    (click)="startDatepicker.open()"
                    readonly
                  />
                  <label for="start" class="label-primary" [innerText]="'Contracts.StartDate' | translate"></label>
                  <mat-datepicker-toggle [for]="startDatepicker" class="absolute right-0 top-0"></mat-datepicker-toggle>
                  <mat-datepicker #startDatepicker></mat-datepicker>
                </div>
                <p class="error" *formError="'start.required'" [innerText]="'Common.Errors.ThisFieldIsRequired' | translate"></p>
              </div>
              <!-- Number of parking spaces -->
              <div class="ar-input-group text-start flex-1">
                <div class="input-primary-container relative">
                  <input id="vehicleQuota" class="input-primary" type="number" inputmode="numeric" step="1" min="1" addEmptyPlaceholder formControlName="parkingSpots" />
                  <label class="hidden lg:block" for="vehicleQuota" [innerText]="'Contracts.NumberOfParkingSpaces' | translate"></label>
                  <label class="lg:hidden" for="vehicleQuota" [innerText]="'Contracts.NumberOfParkingSpacesShort' | translate"></label>
                </div>
                <p class="error" *formError="'parkingSpots.required'" [innerText]="'Common.Errors.ThisFieldIsRequired' | translate"></p>
                <p class="error" *formError="'parkingSpots.min'" [innerText]="'Common.Errors.ValueMustBePositive' | translate"></p>
              </div>
            </div>
            <div class="hidden flex-col lg:flex gap-4">
                <!-- Termination period -->
                <div class="flex-1">
                  <p class="body-medium">
                    <span [innerText]="'Contracts.TerminationPeriod' | translate"></span>
                  </p>

                  <div
                    class="body-small"
                    [innerText]="
                      'Contracts.TerminationPeriodInfo'
                        | translate: { duration: ('Common.Months' | translatePlural: { count: product.termination_period }) }
                    "
                  ></div>
                </div>

                <!-- Minimum contract period -->
                <div class="flex-1" *ngIf="product.min_contract_period">
                  <p class="body-medium">
                    <span [innerText]="'Contracts.MinimumContractPeriod' | translate"></span>
                  </p>
                  <div class="body-small" [innerText]="'Common.Months' | translatePlural: { count: product.min_contract_period }"></div>
                </div>
            </div>
          </div>
          <!-- second column / row on sm -->
          <div class="flex-1">
            <div class="flex">
              <div class="flex-1 flex flex-col gap-4 text-left lg:hidden">
                <!-- Termination period -->
                <div>
                  <p class="body-medium">
                    <span [innerText]="'Contracts.TerminationPeriod' | translate"></span>
                  </p>

                  <div
                    class="body-small"
                    [innerText]="
                      'Contracts.TerminationPeriodInfo'
                        | translate: { duration: ('Common.Months' | translatePlural: { count: product.termination_period }) }
                    "
                  ></div>
                </div>

                <!-- Minimum contract period -->
                <div *ngIf="product.min_contract_period">
                  <p class="body-medium">
                    <span [innerText]="'Contracts.MinimumContractPeriod' | translate"></span>
                  </p>
                  <div class="body-small" [innerText]="'Common.Months' | translatePlural: { count: product.min_contract_period }"></div>
                </div>
              </div>
              <div class="flex-1 flex flex-col gap-2 text-right">
                <!-- Total per month-->
                <div>
                  <div class="body-large">
                    @if (loading) {
                      <mat-progress-spinner class="ml-auto" diameter="20" mode="indeterminate"></mat-progress-spinner>
                    } @else {
                      <span
                        class="text-interaction-dark font-bold"
                        [innerText]="totalPrice | localizedCurrency: product.price.currency"
                      ></span>
                    }
                  </div>
                  <p class="body-medium">
                    <span class="text-interaction-dark" [innerText]="'Contracts.TotalPerMonth' | translate"></span>
                  </p>
                </div>
                <!-- adjusted seasonal price -->
                <div *ngIf="increasedPrice">
                  <div class="body-medium">
                    @if (loading) {
                      <mat-progress-spinner class="ml-auto" diameter="20" mode="indeterminate"></mat-progress-spinner>
                    } @else {
                      <span [innerText]="increasedPrice | localizedCurrency: product.price.currency"></span>
                    }
                  </div>
                  <p class="body-small">
                    <span class="text-neutral-50" [innerText]="getIncreasedPriceString(product)"></span>
                  </p>
                </div>
                <!-- first month price -->
                @if (!isFirstOfMonth) {
                  <div>
                    <div class="body-medium">
                      @if (loading) {
                        <mat-progress-spinner class="ml-auto" diameter="20" mode="indeterminate"></mat-progress-spinner>
                      } @else {
                        <span
                          class=""
                          [innerText]="proratedPrice | localizedCurrency: product.price.currency"
                        ></span>
                      }
                    </div>
                    <p class="body-small">
                      <span class="text-neutral-50" [innerText]="'Contracts.ProratedPrice' | translate"></span>
                    </p>
                  </div>
                }
                <!-- price is including vat -->
                <div class="justify-end mt-2">
                  <p *ngIf="vatPercent" class="text-right body-small">
                    <span class="text-interaction-dark" [innerText]="'Contracts.PriceIncludingVAT' | translate: {vatPercent: vatPercent | localizedPercentage} | mwstUppercase"></span>
                  </p>
                </div> 
              </div>
            </div>
          </div>
        </div>

        <hr class="my-4" *ngIf="product.price_adjustment || showVpi" />

        <div class="flex text-left mt-2 gap-4 flex-wrap" *ngIf="product.price_adjustment">
          <div class="flex-grow">
            <div class="flex flex-1 gap-4">
              <div class="flex-1">
                <div class="body-medium">{{ getPriceIncreaseString(product) }}</div>
                <p class="body-small">
                  <span class="text-neutral-50" [innerText]="'Contracts.PriceIncreaseLabel' | translate"></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex text-left mt-2 gap-4 flex-wrap" *ngIf="showVpi">
          <div class="flex-grow">
            <div class="flex flex-1 gap-4">
              <div class="flex-1">
                <div
                  class="body-medium"
                  [innerHTML]="'Contracts.VpiContext' | translate: { url: providerLinks.terms_and_conditions.url }"
                ></div>
                <p class="body-small">
                  <span class="text-neutral-50" [innerText]="'Contracts.VpiLabel' | translate"></span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <hr class="my-4" />

        <div class="body-large text-decoration-dark text-left mb-2" [innerText]="'Contracts.EligibleVehicles' | translate"></div>
        <div class="ar-input-group text-left">
          <app-contract-vehicles
            [userLicensePlates]="licensePlates"
            [vehicleQuota]="contractForm.value.parkingSpots"
            (onLicensePlatesChanged)="updateLicensePlates($event)"
          />
        </div>

        <hr class="my-6" />

        <div class="ar-input-group text-left">
          <div class="flex items-center gap-2">
            <input id="switch" type="checkbox" class="switch" formControlName="termsAndConditions" />
            <label
              for="switch"
              class="body-medium"
              [innerHtml]="'Common.IHaveReadAndAcceptTheTermsAndConditions' | translate: { url: providerLinks.terms_and_conditions.url }"
            ></label>
          </div>
          <p
            class="error"
            *formError="'termsAndConditions.required'"
            [innerText]="'Common.Errors.YouHaveToAcceptTheTermsAndConditions' | translate"
          ></p>
        </div>
        <p
          class="body-medium text-left mt-4 mb-6"
          [innerHtml]="'Common.AdditionalDataInformation' | translate: { url: providerLinks.privacy_policy.url }"
        ></p>
      </div>
    </div>

    <arivo-step-footer>
      <button
        class="button-primary"
        type="submit"
        [innerText]="'Contracts.ConcludeContractWithCosts' | translate"
        [disabled]="loading"
      ></button>
      <button
        class="button-primary-text"
        type="button"
        (click)="back()"
        [innerText]="'Common.Back' | translate"
        [disabled]="loading"
      ></button>
    </arivo-step-footer>
  </form>
}
